import ApiClient from './ApiClient';

class AiConfigApi extends ApiClient {
  constructor() {
    super('ai_config', { accountScoped: true });
  }

  getConfig() {
    return axios.get(`${this.url}/config`);
  }

  saveConfig(data) {
    return axios.put(`${this.url}/config`, data);
  }

  fetchModels(data) {
    return axios.post(`${this.url}/models`, data);
  }
}

export default new AiConfigApi();